import React, { useState, useRef, useEffect } from 'react';
// components
import TicketsListTableHeaderRow from './rows/ticketsListTableHeaderRow';
import NonSticky from '../../ui/sticky/nonSticky';
import Sticky from '../../ui/sticky/sticky';
import TicketsListTableDateRow from './rows/ticketsListTableDateRow';
import TicketsListTableTicketRow from './rows/ticketsListTableTicketRow';
import FixedWithContainer from '../../ui/containers/fixedWithContainer';
import { groupTicketsByDate } from 'modules/emergencies/utils/dateUtils';
import { useScrollCacheHook } from '@ontruck/fe-ui';
import styled from 'styled-components';
import BasicLoader from 'modules/emergencies/components/ui/loaders/basicLoader';
import { LoadMoreButton } from '../../ui/buttons/LoadMoreButton';

const InfiniteLoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 32px;
  ${LoadMoreButton} {
    width: 200px;
  }
`;
const LoaderContainer = styled.div`
  padding-top: 16px;
`;

const ObservableContainer = ({ onObserv, children }) => {
  const [isIntersecting, setIsIntersecting] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsIntersecting(entry.isIntersecting);
      },
      { rootMargin: '' }
    );
    observer.observe(ref.current);

    return () => observer.disconnect();
  }, [isIntersecting]);

  useEffect(() => {
    if (isIntersecting) {
      onObserv();
    }
  }, [isIntersecting, onObserv]);
  return <div ref={ref}>{children}</div>;
};

const TicketsListTable = ({ ticketsListData }) => {
  const { manuallyScrollToElementRef, scrollToSavedCache, saveCurrentPositionToCache } =
    useScrollCacheHook('tickets-list');

  useEffect(() => {
    scrollToSavedCache();
  }, [scrollToSavedCache]);

  const tickets = ticketsListData.ungroupedTickets.flat();
  const ticketsGrouped = groupTicketsByDate({ items: tickets });
  const { isEmpty, isReachingEnd, isLoadingMore, reset } = ticketsListData;

  return (
    <>
      <FixedWithContainer onScroll={saveCurrentPositionToCache} ref={manuallyScrollToElementRef}>
        <Sticky>
          <TicketsListTableHeaderRow />
        </Sticky>
        <NonSticky>
          {ticketsGrouped.map((ticketsGroupedByDay, index) => (
            <React.Fragment key={index}>
              <TicketsListTableDateRow key={index} ticketsGroupedByDay={ticketsGroupedByDay} />
              {ticketsGroupedByDay.tickets.map((ticket) => (
                <TicketsListTableTicketRow key={ticket.id} ticket={ticket} reset={reset} />
              ))}
            </React.Fragment>
          ))}
          <InfiniteLoaderContainer>
            {isLoadingMore ? (
              <LoaderContainer>
                <BasicLoader size={10} />
              </LoaderContainer>
            ) : (
              <>
                {!isEmpty && !isReachingEnd && (
                  <ObservableContainer onObserv={ticketsListData.loadMore}>
                    <LoaderContainer>
                      <BasicLoader size={10} />
                    </LoaderContainer>
                  </ObservableContainer>
                )}
              </>
            )}
          </InfiniteLoaderContainer>
        </NonSticky>
      </FixedWithContainer>
    </>
  );
};

export default TicketsListTable;
